(function (angular) {
	'use strict';

	angular
		.module('viewPlanModule')
		.directive('beforeAfterSlider', [
			'$document',
			'$timeout',
			'STATIC_BASE_PATH',
			beforeAfterSliderFunction
		]);

	function beforeAfterSliderFunction($document, $timeout, STATIC_BASE_PATH) {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: STATIC_BASE_PATH + '/' + 'static/html/ria/view-plan/before-after-slider.html',
			scope: {
				beforeImgSrc: '@',
				afterImgSrc: '@'
			},
			link: function ($scope, $elem, $attrs) {
				$scope.elementWidth = $elem[0].offsetWidth;
				$scope.overlayWidth = $scope.elementWidth / 2;
			}
		};
	}
})(window.angular);